module.exports = __webpack_public_path__ + "static/media/controlbox.8083e206.jpg";